import { Stack } from "expo-router";

import { colors } from "@/lib/theme";

export default function OnboardingLayout() {
    return (
        <Stack
            screenOptions={{
                headerStyle: { backgroundColor: colors.background },
                headerTintColor: colors.textPrimary,
                headerTitleStyle: { fontWeight: "bold" as const },
                headerShadowVisible: false
            }}
        >
            <Stack.Screen name="index" options={{ headerShown: false }} />
            {/* The section screen renders its own header (topBar). Hide the Stack
                header here so the raw route name "section/[sectionId]" never
                flashes as the title during the loading transition. */}
            <Stack.Screen
                name="section/[sectionId]"
                options={{ headerShown: false, headerBackTitle: "Back" }}
            />
            {/*  Same reason as the section screen above: this screen renders its
                own topBar, and it declares `headerShown: false` itself — but only
                once it has data. Its loading and error branches return early,
                before that declaration, so the raw route name
                "subsection/[subsectionId]" was the header for the whole spinner.
                Setting it here covers every render path. */}
            <Stack.Screen
                name="subsection/[subsectionId]"
                options={{ headerShown: false, headerBackTitle: "Back" }}
            />
            <Stack.Screen
                name="identity-verification"
                options={{ title: "Identity Verification", headerBackTitle: "Back" }}
            />
        </Stack>
    );
}
